document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-solza-intro-toggle]');
  if (toggle) {
    var text = document.getElementById(toggle.getAttribute('aria-controls'));
    if (text) {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      text.classList.toggle('is-expanded', !expanded);
      toggle.textContent = expanded ? toggle.dataset.labelMore : toggle.dataset.labelLess;
    }
    return;
  }

  var navButton = event.target.closest('[data-slider-prev], [data-slider-next]');
  if (navButton) {
    var wrap = navButton.closest('.solza-collection-card__slider-wrap');
    var track = wrap && wrap.querySelector('[data-slider-track]');
    if (track) {
      var amount = track.clientWidth * 0.8;
      track.scrollBy({
        left: navButton.hasAttribute('data-slider-next') ? amount : -amount,
        behavior: 'smooth',
      });
    }
  }
});
